<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps">
<p class="fm-title"><b>Maps</b><span epub:type="pagebreak" id="pageviii"></span></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_1">Corsica</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_2">St Lucia</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_3">Ireland</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_4">North Holland</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_5">Environs of Alexandria</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_6">Lake Mareotis, Egypt</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_7">Sicily</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_8">Spain – the advance</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_9">Spain</a></p>
<p class="list-fig"><a href="#/xhtml/10_Maps1#map_10">Battle of Corunna</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Maps.vue?96abcb48